"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.LinkContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _emotionTheming = require("emotion-theming");

var _GlobalStyle = _interopRequireDefault(require("../GlobalStyle"));

var LinkContext = _react.default.createContext(); // eslint-disable-next-line react/prop-types


exports.LinkContext = LinkContext;

function MainTheme(_ref) {
  var children = _ref.children,
      link = _ref.link,
      rest = _objectWithoutProperties(_ref, ["children", "link"]);

  var externalLink = link;
  return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, rest, /*#__PURE__*/_react.default.createElement(LinkContext.Provider, {
    value: {
      link: externalLink
    }
  }, /*#__PURE__*/_react.default.createElement(_GlobalStyle.default, null), children));
}

var _default = MainTheme;
exports.default = _default;